import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EContentFullscreenActionTypes {
  Open = 'contentFullscreen/open',
  Set = 'contentFullscreen/set',
  Close = 'contentFullscreen/close',
}

export interface IContentFullscreenOpenPayload {
  selectedImageUid: string | null;
}

export type TContentFullscreenActions =
  | ITypedReduxAction<EContentFullscreenActionTypes.Open, IContentFullscreenOpenPayload>
  | ITypedReduxAction<EContentFullscreenActionTypes.Set, IContentFullscreenOpenPayload>
  | ITypedReduxAction<EContentFullscreenActionTypes.Close, void>;
